@if (currentMobileNumber(); as currentMobileNumber) {
  <div class="flex flex-col justify-between">
    <div class="flex flex-col gap-1 py-2">
      <div class="text-xl leading-none font-semibold tracking-tight">Numéro de téléphone portable</div>
      <div class="text-gray-11">{{ currentMobileNumber.mobileNumber | obfuscateMobileNumber }}</div>
    </div>
  </div>
}
